import { z } from 'zod';

/**
 * Admin subscription grant types - issue #910.
 *
 * Shared enums for the `admin_subscription_grants` audit table and the
 * `scripts/admin-subscription-grant.ts` CLI. Not exposed via any ts-rest
 * contract - this is an internal admin tool, not an HTTP-facing feature.
 */

export const AdminSubscriptionGrantTypeSchema = z.enum([
  'trial',
  'discount',
  'comp',
]);
export type AdminSubscriptionGrantType = z.infer<
  typeof AdminSubscriptionGrantTypeSchema
>;

export const AdminSubscriptionGrantStatusSchema = z.enum([
  'active',
  'pending',
  'apply_failed',
  'activation_failed',
  'revert_pending',
  'revert_failed',
  'reverted',
  'expired',
  'superseded',
]);
export type AdminSubscriptionGrantStatus = z.infer<
  typeof AdminSubscriptionGrantStatusSchema
>;

export interface AdminSubscriptionGrantRow {
  id: string;
  target_user_id: string;
  target_email: string;
  granted_by_admin_id: string;
  grant_type: AdminSubscriptionGrantType;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  stripe_coupon_id: string | null;
  created_subscription: boolean;
  original_trial_end: string | null;
  original_cancel_at: string | null;
  original_discount_coupon_id: string | null;
  original_promotion_code_id: string | null;
  discount_percent_off: number | null;
  discount_amount_off_cents: number | null;
  reason: string;
  status: AdminSubscriptionGrantStatus;
  operation_error: string | null;
  replaces_grant_id: string | null;
  expires_at: string | null;
  created_at: string;
  updated_at: string;
  reverted_at: string | null;
  reverted_by_admin_id: string | null;
  revoked_reason: string | null;
}
